(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('iddLinks', ['FormService', 'formData', 'errorHandler', '$q','$rootScope', function (formService, formData, errorHandler, $q,$rootScope) {
            return {
                restrict: 'EA',
                link: function ($scope, element, attr) {

                    $scope.c4lTitle = attr.c4lTitle;   
                    $scope.essentialTitle = attr.essentialTitle;

                },
                templateUrl: 'directives/idd-links/templates/idd-links.html'
            };
        }]);
})(window, window.angular);